// extracted by mini-css-extract-plugin
export default {"pageContainer":"Unauthorized_pageContainer__of53a","bigText":"Unauthorized_bigText__c3t6i"};